import { render, staticRenderFns } from "./AccessModal.vue?vue&type=template&id=c21ccc7c&scoped=true&"
import script from "./AccessModal.vue?vue&type=script&lang=js&"
export * from "./AccessModal.vue?vue&type=script&lang=js&"
import style0 from "./AccessModal.vue?vue&type=style&index=0&id=c21ccc7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21ccc7c",
  null
  
)

export default component.exports